import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { MultilingualKeyDto } from '@pharmac-extranet/management-api'
import { PharmacIcon } from '@pharmac/ui'

export const CategoryListItemRoot = styled.div<{ isDisabled?: boolean }>`
  border: var(--button-secondary-border-top);
  border-radius: var(--border-radius-tiny);

  display: flex;
  flex-direction: column;

  width: 100%;
  margin-bottom: var(--spacing-small);

  cursor: pointer;

  transition:
    transform 0.2s ease-in-out,
    margin 0.2s linear;

  :hover {
    margin-bottom: var(--spacing-small);
    button {
      font-size: calc(var(--input-medium-font-size) + 1px);
    }
  }

  ${(p) =>
    p.isDisabled &&
    css`
      &:hover {
        cursor: not-allowed;
      }

      button:hover {
        cursor: not-allowed;
      }
    `}
`

export const CategoryListItemCategory = styled.div`
  background-color: transparent;
  border-radius: var(--border-radius-tiny);

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  padding: 0 var(--spacing-small);

  :nth-of-type(1) {
    button:first-of-type {
      font-weight: bold;
    }
  }

  :nth-of-type(2) {
    margin: 1px 0;
    border-top: 1px solid var(--color-accent-5);
    border-bottom: 1px solid var(--color-accent-5);
    border-radius: 0;
  }
`

export const CategoryListItemLabelButton = styled.button`
  padding: var(--input-medium-padding-vertical);
  outline: none;
  border: none;
  background-color: transparent;
  text-align: left;
  font-family: var(--font-family-primary);
  font-size: var(--input-medium-font-size);
  width: 100%;
  cursor: pointer;
  transition: var(--transition-cubic-bezier);
`

export const CategoryListItemButton = styled.button`
  background-color: transparent;
  outline: none;
  border: none;

  padding: 0 var(--spacing-tiny);

  cursor: pointer;

  svg {
    transform: translateY(10%);
  }

  :nth-of-type(2) {
    margin-left: auto;
  }

  &:disabled {
    &:hover {
      cursor: not-allowed;
      color: var(--color-accent-4);
    }
  }

  :hover {
    svg {
      color: var(--color-primary);
    }
  }
`

export type CategoryListItemProps = {
  category: CategoryListItemDto
  onClick?: () => void
  isActive?: boolean
  isVisible?: boolean
}

export type CategoryListItemFunctionProps = {
  onClick?: () => void
  disabled?: boolean
}

export type CategoryListItemDto = {
  name: MultilingualKeyDto
  itemCount?: number
  hideFn?: CategoryListItemFunctionProps
  editFn?: CategoryListItemFunctionProps
}

export const ExtranetCategoryListItem = ({
  category,
  onClick,
  isActive,
  isVisible,
}: CategoryListItemProps) => {
  return (
    <CategoryListItemRoot
      style={{
        background: isActive ? '#f3e9f4' : 'var(--color-white)',
        opacity: !isVisible ? 0.5 : 1,
      }}
    >
      <CategoryListItemCategory>
        <CategoryListItemLabelButton onClick={onClick}>
          FI: {category.name.fi} ({category.itemCount})
        </CategoryListItemLabelButton>

        {typeof category.hideFn !== 'undefined' && (
          <CategoryListItemButton
            disabled={!!category.hideFn.disabled}
            onClick={category.hideFn.onClick}
          >
            {!isVisible ? (
              <PharmacIcon
                icon="eyeOff"
                size="18px"
              />
            ) : (
              <PharmacIcon
                icon="eye"
                size="18px"
              />
            )}
          </CategoryListItemButton>
        )}

        {typeof category.editFn !== 'undefined' && (
          <CategoryListItemButton
            onClick={category.editFn.onClick}
            disabled={!!category.editFn.disabled}
          >
            <PharmacIcon
              icon="edit3"
              size="18px"
            />
          </CategoryListItemButton>
        )}
      </CategoryListItemCategory>
      <CategoryListItemCategory>
        <CategoryListItemLabelButton onClick={onClick}>
          EN: {category.name.en}
        </CategoryListItemLabelButton>
      </CategoryListItemCategory>
      <CategoryListItemCategory>
        <CategoryListItemLabelButton onClick={onClick}>
          SV: {category.name.sv}
        </CategoryListItemLabelButton>
      </CategoryListItemCategory>
    </CategoryListItemRoot>
  )
}
